import SEO from '../Components/SEO';
import Breadcrumb from '../Components/Breadcrumb';
import { ActivityLayout } from '../Components/activity-layout';

const guideImage = '/Images/teacher1-1280x470.webp';

const guideLevels = [
  {
    level: 'start',
    label: 'Getting Started',
    tagline: 'Chapter one',
    cards: [
      {
        title: 'Know Your Students',
        image: '/Images/online-teacher.webp',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        links: [{ text: 'Level Test', to: '/level-test/level-test' }],
      },
      {
        title: 'Plan Your First Lesson',
        image: '/Images/1person2.webp',
        desc: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        links: [{ text: 'Lesson Plans', to: '/lesson-plans' }],
      },
      {
        title: 'Brush Up on Your English',
        image: '/Images/tutor2-1280x470.webp',
        desc: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        links: [{ text: 'Grammar Exercises', to: '/grammar-exercises' }],
      },
    ],
  },
  {
    level: 'plan',
    label: 'Planning Lessons',
    tagline: 'Chapter two',
    cards: [
      {
        title: 'Build a Lesson Around a Goal',
        image: '/Images/2people1.webp',
        desc: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        links: [{ text: 'Lesson Plans', to: '/lesson-plans' }],
      },
      {
        title: 'Sequence Grammar Points',
        image: '/Images/grammar1.webp',
        desc: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.',
        links: [{ text: 'Grammar Exercises', to: '/grammar-exercises' }],
      },
      {
        title: 'Recycle Vocabulary',
        image: '/Images/vocabulary.webp',
        desc: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
        links: [{ text: 'Vocabulary Exercises', to: '/vocabulary-exercises' }],
      },
    ],
  },
  {
    level: 'skills',
    label: 'Teaching the Four Skills',
    tagline: 'Chapter three',
    cards: [
      {
        title: 'Reading',
        image: '/Images/reading.webp',
        desc: 'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.',
        links: [{ text: 'Reading Exercises', to: '/reading-exercises' }],
      },
      {
        title: 'Speaking',
        image: '/Images/speaking.webp',
        desc: 'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.',
        links: [{ text: 'Speaking Exercises', to: '/speaking-exercises' }],
      },
      {
        title: 'Writing',
        image: '/Images/writing1-1280x470.webp',
        desc: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum.',
        links: [{ text: 'Writing Exercises', to: '/writing-exercises' }],
      },
    ],
  },
  {
    level: 'assess',
    label: 'Practice and Assessment',
    tagline: 'Chapter four',
    cards: [
      {
        title: 'Quiz Your Students',
        image: '/Images/quiz1.webp',
        desc: 'Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur.',
        links: [{ text: 'Quizzes', to: '/quizzes' }],
      },
      {
        title: 'Flashcard Drills',
        image: '/Images/flashcards1.webp',
        desc: 'Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime.',
        links: [{ text: 'Flashcards', to: '/flashcards' }],
      },
      {
        title: 'Watch and Discuss',
        image: '/Images/3people1a.webp',
        desc: 'Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates.',
        links: [{ text: 'Video Exercises', to: '/videos' }],
      },
    ],
  },
];

const TeachEnglish = () => {
  return (
    <ActivityLayout
      title="How to Teach English"
      eyebrow="Teaching Guide"
      image={guideImage}
      intro="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
      seoContent={[
        'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
      ]}
      levels={guideLevels}
    >
      <SEO
        title='How to Teach English: A Practical Guide | English Exam Exercises'
        description='A practical guide on how to teach English online and in person. Lesson planning tips plus grammar, vocabulary, reading, speaking and video resources for teachers.'
        name='English Exam Exercises'
        type='article'
        image={guideImage} />
      <Breadcrumb />
    </ActivityLayout>
  );
};

export default TeachEnglish;
